/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from 'axios';

export const handleDownloadFile = async (file: string) => {
  const response = await axios.get(file || '', { responseType: 'blob' });
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = file.split('/').pop() || '';
  link.click();
  URL.revokeObjectURL(link.href);
};

export const chunkItems = (array: Array<any>, chunkSize: number) => {
  return (array || []).reduce((result, currItem, index) => {
    const chunkIndex = Math.floor(index / chunkSize);
    if (!result[chunkIndex]) {
      result[chunkIndex] = [];
    }
    result[chunkIndex].push(currItem);
    return result;
  }, []);
};
